import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BcpLocalStorage, BcpSessionStorage } from '@bcp/js-storage';
import { LogInsight } from 'src/app/contexts/login/domain/log-insight';
import { InsightService } from 'src/app/contexts/login/infrastructure/services/insight.service';
import { environment } from 'src/environments/environment';
import * as forge from 'node-forge';
import { CryptoService } from './crypto.service';
import { SessionStorageRepository } from 'src/app/contexts/shared/storage/session-storage.repository';
import { CHATBOT_STORAGE_KEY } from 'src/app/contexts/shared/constants/chatbot.constants';

@Injectable({
  providedIn: 'root'
})
export class B2cService {
  private sessionStorageRepository = new SessionStorageRepository(new BcpSessionStorage());
  
  storage = new BcpLocalStorage();
  httpClient = inject(HttpClient);
  API_URL = `${environment.APIUX}/channel/baut/`;
  private readonly authorizePath = '/oauth2/v2.0/authorize';


  constructor(private http: HttpClient, private insightService: InsightService, private cryptoService: CryptoService) {
  }

  async validation() {
    let customerId = sessionStorage.getItem('customerId');
    let conversationId = sessionStorage.getItem('conversationId');
    let channelId = sessionStorage.getItem('channelId');
    let chatbotId = sessionStorage.getItem('chatbotId');

    const params = { customerId, conversationId, channelId, chatbotId }

    let urlAuth = `${this.API_URL}v1/customers/${customerId}/retrieve?conversationId=${conversationId}&channelId=${channelId}&chatbotId=${chatbotId}`;
    try {

      const result: any = await this.http.get(urlAuth).toPromise();

      if (result?.customerReference) {
        this.sessionStorageRepository.save(CHATBOT_STORAGE_KEY, result.chatbotId);
        let logInsight: LogInsight = { statusCode: 200, statusText: 'Ok', params: params, message: 'Respuesta Ok del endpoint v1/customers/{customer-id-hash}/retrieve' };
        this.insightService.trackTrace(`${JSON.stringify(logInsight)}`)

        return { status: true, code: result?.customerReference };

      } else {
        let logInsight: LogInsight = { params: params, message: 'Respuesta Error sessionId del endpoint v1/customers/{customer-id-hash}/retrieve' };
        this.insightService.trackTrace(`${JSON.stringify(logInsight)}`)
        return { status: false, code: result?.status };
      }
    } catch (error: any) {
      let logInsight: LogInsight = { statusCode: error?.status, statusText: error?.statusText, params: params, message: 'Error del servicio del endpoint v1/customers/{customer-id-hash}/retrieve', response: error?.error };
      this.insightService.trackException(`${JSON.stringify(logInsight)}`)
      return { status: false, code: error?.status };
    }
  }

  async verification() {

    let customerId = sessionStorage.getItem('customerId');
    let conversationId = sessionStorage.getItem('conversationId');
    let channelId = sessionStorage.getItem('channelId');
    let chatbotId = sessionStorage.getItem('chatbotId');

    let urlAuth = `${this.API_URL}v1/sessions/register`;

    const params = {
      'customerId': customerId,
      'conversationId': conversationId,
      'channelId': channelId,
      'chatbotId': chatbotId
    }

    try {
      const result: any = await this.http.post(urlAuth, params).toPromise();
      if (result?.sessionId) {
        let logInsight: LogInsight = { statusCode: 200, statusText: 'Ok', params: params, message: 'Respuesta Ok del endpoint v1/sessions/register' };
        this.insightService.trackTrace(`${JSON.stringify(logInsight)}`)

        return { status: true, code: result?.sessionId };
      } else {
        let logInsight: LogInsight = { params: params, message: 'Respuesta Error sessionId del endpoint v1/sessions/register' };
        this.insightService.trackTrace(`${JSON.stringify(logInsight)}`)
        return { status: false, code: result?.status };
      }
    } catch (error: any) {
      let logInsight: LogInsight = { statusCode: error?.status, statusText: error?.statusText, params: params, message: 'Error del servicio del endpoint v1/sessions/register', response: error?.error };
      this.insightService.trackException(`${JSON.stringify(logInsight)}`)
      return { status: false, code: error?.status };
    }
  }

  async getTokenB2c(code: any): Promise<boolean> {

    const code_verifier = this.getCodeVerifier();

    const data = [
      `grant_type=authorization_code`,
      `client_id=${environment.b2c.clientId}`,
      `redirect_uri=${this.convertToUTF8(environment.b2c.urlRedirect)}`,
      `code=${code}`,
      `code_verifier=${code_verifier}`
    ];
    let urlAuth = `${environment.b2c.urlBase}/B2C_1A_SIGNIN/oauth2/v2.0/token?${data.join('&')}`;

    try {
      const response: any = await this.http.post(urlAuth, {}).toPromise();

      if (response['access_token']) {
        sessionStorage.setItem('auth_token', response['access_token']);

        let logInsight: LogInsight = { statusCode: 200, statusText: 'Ok', params: data, message: 'Respuesta Ok del endpoint B2C_1A_SIGNIN/oauth2/v2.0/token con accessToken' };
        this.insightService.trackTrace(`${JSON.stringify(logInsight)}`);

        return true;
      }
      if (response['id_token']) {
        sessionStorage.setItem('auth_token', response['id_token']);
        let logInsight: LogInsight = { statusCode: 200, statusText: 'Ok', params: data, message: 'Respuesta Ok del endpoint B2C_1A_SIGNIN/oauth2/v2.0/token con id_token' };
        this.insightService.trackTrace(`${JSON.stringify(logInsight)}`);

        return true;
      }

      let logInsight: LogInsight = { statusCode: 409, params: data, message: 'Respuesta Error access_token del endpoint B2C_1A_SIGNIN/oauth2/v2.0/token' };

      this.insightService.trackTrace(`${JSON.stringify(logInsight)}`);

      return false;

    } catch (error: any) {

      let logInsight: LogInsight = { statusCode: error?.status, statusText: error?.statusText, params: data, message: 'Error del servicio del endpoint B2C_1A_SIGNIN/oauth2/v2.0/token', response: error?.error };
      this.insightService.trackException(`${JSON.stringify(logInsight)}`)
      return false;
    }

  }

  async getDataB2c(code: any) {
    let value: boolean = false;
    const conditionToken = await this.getTokenB2c(code);
    if (!conditionToken) {
      return value;
    }

    try {
      const response = await this.verification();
      return response.status;
    } catch (error) {
      return value;
    }

  }

  getUrlRedirect(code: any) {
    const documentType = code?.documentType;

    const document = this.maskString(code?.documentNumber);

    const documentEncrypted = this.cryptoService.encrypt256(code?.documentNumber + '' + code?.documentType);

    //EIDC
    const eidc = this.letsEncryptRSA(code?.documentNumber + '' + code?.documentType);

    const eidcEncoder = this.convertToUTF8(eidc);

    const code_verifier = this.cryptoService.base64URLEncode(this.starRandomWithCryptoRand(96));

    const code_challenge = this.generateCodeChallenge(code_verifier);

    const state = this.starRandomWithCryptoRand(50);
    this.saveCodeVerifier(code_verifier, state);

    const data = { document, documentType, documentEncrypted, code_challenge, state, eidcEncoder };

    return this.assembleUrl(data);
  }

  clearDataB2c() {
    this.storage.removeItem('code_verifier');
    this.storage.removeItem('state');
  }

  saveCodeVerifier(code_verifier: string, state: string) {
    this.storage.setItem('code_verifier', code_verifier);
    this.storage.setItem('state', state);
  }

  getCodeVerifier(): string {
    return this.storage.getItem('code_verifier') ?? '';
  }

  assembleUrl(data: any): string {
    const { document, documentType, documentEncrypted, code_challenge, state, eidcEncoder } = data;
    return `${environment.b2c.urlBase}${this.authorizePath}?p=B2C_1A_SIGNIN&client_id=${environment.b2c.clientId}&nonce=defaultNonce&redirect_uri=${this.convertToUTF8(environment.b2c.urlRedirect)}&scope=${environment.b2c.scope}&channel_code=${environment.b2c.code}&response_type=code&prompt=login&document=${document}&doc_type=${documentType}&person_type=1&text_description=Banca%20por%20Internet&text_button=Continuar&return_url=${this.convertToUTF8(environment.b2c.urlReturn)}&code_challenge=${code_challenge}&code_challenge_method=S256&fa_allowed=false&user=${this.convertToUTF8(documentEncrypted)}&epidc=${eidcEncoder}&state=${state}`;
  }

  letsEncryptRSA = (data: unknown) => {
    const formattedPublicKey = `-----BEGIN PUBLIC KEY-----\r\n${environment.publicKeyBase64B2c}\r\n-----END PUBLIC KEY-----\r\n`;
    const publicKey = forge.pki.publicKeyFromPem(formattedPublicKey);
    const encrypted = publicKey.encrypt(forge.util.encodeUtf8(JSON.stringify(data)), 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: {
        md: forge.md.sha256.create(),
      },
    });

    return forge.util.encode64(encrypted);
  };

  maskString(input: string): string {
    if (input.length <= 2) {
      return input; // Si la cadena tiene 2 o menos caracteres, no se enmascara
    }
    const maskedPart = '*'.repeat(input.length - 2);
    const visiblePart = input.slice(-2);
    return maskedPart + visiblePart;
  }

  //CODE VERIFY code_verifier 128
  starRandomWithCryptoRand(length: number) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const random = crypto.getRandomValues(new Uint8Array(length));
    let objectID = '';
    for (const element of random) {
      objectID += chars[element % chars.length];
    }

    return objectID;
  }

  generateCodeChallenge(codeVerifier: string): string {
    const data = this.sha256(codeVerifier);
    return this.cryptoService.base64URLEncode(data);
  }

  sha256(plain: string) {
    return forge.md.sha256.create().update(plain).digest().bytes();
  }

  convertToUTF8(input: string): string {
    return this.cryptoService.convertToUTF8(input);
  }

  removeSpacesFromUrl(url: string): string {
    return url.replace(/\s+/g, '');
  }

  isAllowedRedirectUrl(rawUrl: string): boolean {
    try {
      const target = new URL(rawUrl);
      const allowedBase = new URL(environment.b2c.urlBase);

      return (
        target.protocol === 'https:' &&
        target.origin === allowedBase.origin &&
        target.pathname === allowedBase.pathname + this.authorizePath
      );
    } catch {
      return false;
    }
  }
}
